import {useEffect, useState} from 'react';
import {Card, Grid, Typography} from "@mui/material";
import EventDetail from "./Widgets/EventDetail";
import Button from "@mui/material/Button";
import {Email} from "@mui/icons-material";
import EventEmailGrid from "./Widgets/EventEmailGrid";
import * as React from "react";
import {connect} from "react-redux";
import {actions as opportunityActions, selectors as opportunitySelectors} from "../../../Ducks/opportunity";
import {bindActionCreators} from "redux";
import EventOverviewGroupEmailForm from "./Widgets/EventOverviewGroupEmailForm";
import {deleteGroupEmail, getGroupEmails} from "../../../API/eventsOverview";
import {ADD, EDIT} from "../../Utils/constants";
import Swal from "sweetalert2";
import {selectors as userSelectors} from "../../../Ducks/users";
import {actions as eventsOverviewActions, selectors as eventsOverviewSelectors} from "../../../Ducks/eventsOverview";

const EventOverviewEmailView = (props) => {
    const {event, mails, getMails, activeUsers, eventDetails, getEventDetails} = props;
    const [groupEmails, setGroupEmails] = useState([]);
    const [showGroupEmailForm, setShowGroupEmailForm] = useState(false);
    const [selectedGroupEmail, setSelectedGroupEmail] = useState(null);
    const [groupEmailFormType, setGroupEmailFormType] = useState(ADD);

    const fetchGroupEmails = (eventId) => {
        getGroupEmails(eventId).then(res => {
            setGroupEmails(res.main.groupEmails)
        })
    }

    useEffect(() => {
        if (event) {
            const {product_id} = event;

            let payload = {
                productId: product_id,
                type: "group_email",
            };
            getMails(payload);

            setShowGroupEmailForm(false);
            setSelectedGroupEmail(null);
            setGroupEmailFormType(ADD);

            getEventDetails(event.event_id);
        }
    }, [event, getMails, getEventDetails]);

    useEffect(() => {
        if (event) {
            fetchGroupEmails(event.event_id);
        }
    }, [event])

    const handleCloseEventGroupEmailForm = (refresh = false) => {
        if (refresh) {
            if (groupEmailFormType === ADD) {
                fetchGroupEmails(event.event_id);
            } else if (groupEmailFormType === EDIT && selectedGroupEmail !== null) {
                fetchGroupEmails(selectedGroupEmail.event_id);
            }
        }

        setShowGroupEmailForm(false);
        setSelectedGroupEmail(null);
        setGroupEmailFormType(ADD);
    }

    const viewOrEditSelectedGroupEmail = (email, type) => {
        if (email) {
            setSelectedGroupEmail(email);
            setGroupEmailFormType(type);
            setShowGroupEmailForm(true);
        }
    }

    const handleDeleteGroupEmailClick = (data) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                deleteGroupEmail(data.event_id, data.event_group_email_id).then(() => {
                    fetchGroupEmails(data.event_id);
                }).catch(() => {
                });
            }
        });
    }

    return (
        <Grid container sx={{paddingTop: "20px"}}>
            <Card style={{width: "100%", padding: "12px", margin: "10px"}}>
                <Typography component='h1' variant='h6' align='left' color='textPrimary'
                            gutterBottom>
                    Event Details
                </Typography>
                <EventDetail event={event}/>
            </Card>
            <Card style={{width: "100%", padding: "12px", textAlign: 'left', margin: "10px"}}>
                <Typography component='h1' variant='h6' align='left' color='textPrimary'
                            gutterBottom>
                    Group Emails
                </Typography>
                <Grid item xs={12} sx={{textAlign: 'right', justifyContent: 'right', paddingBottom: '20px'}}>
                    <Button variant="contained" color="primary"
                            onClick={() => {
                                setShowGroupEmailForm(true);
                    }}>
                        <Email sx={{paddingRight: '5px'}}/>Compose Email
                    </Button>
                </Grid>
                {
                    showGroupEmailForm &&
                    <Grid item xs={12} sx={{paddingBottom: '20px'}}>
                        <EventOverviewGroupEmailForm
                            event={event}
                            mails={mails}
                            type={groupEmailFormType}
                            selectedGroupEmail={selectedGroupEmail}
                            activeUsers={activeUsers}
                            networkCoordinator={eventDetails?.network_coordinator}
                            networkDirectors={eventDetails?.network_directors}
                            handleClose={handleCloseEventGroupEmailForm}/>
                    </Grid>
                }

                <EventEmailGrid
                    emails={groupEmails}
                    handleEmailSelection={viewOrEditSelectedGroupEmail}
                    handleDeleteGroupEmail={handleDeleteGroupEmailClick}
                    />
            </Card>
        </Grid>
    )
}

const mapStateToProps = (state) => ({
    mails: opportunitySelectors.mails(state),
    activeUsers: userSelectors.activeUsers(state),
    eventDetails: eventsOverviewSelectors.eventDetails(state)
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getMails: opportunityActions.getMails,
            getEventDetails: eventsOverviewActions.getEventDetails,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(EventOverviewEmailView);